<p-panel styleClass="no-padding-panel panel-shadow">
  <p-header>
    <div class="panel-header">Supplier Information</div>
  </p-header>

  <div [class.ghost]="loadingJob" class="supplier-info">
    <div class="flex-grow-1 ghost-values">
      <div class="label-value">
        <div class="label">Name:</div>
        <div class="value">{{ job?.name || '-' }}</div>
      </div>
      <div class="label-value">
        <div class="label">Phone Number:</div>
        <div class="value">
          <a href="tel:{{ job?.phoneNumber || '-' }}">{{ job?.phoneNumber || '' }} </a>
        </div>
      </div>
      <div class="label-value">
        <div class="label">Postcode:</div>
        <div class="value">{{ job?.postcode || '-' }}</div>
      </div>
      <div class="label-value">
        <div class="label">Region:</div>
        <div class="value">{{ job?.regionName || '-' }}</div>
      </div>
    </div>
    <div class="flex-grow-1 ghost-values">
      <div class="label-value">
        <div class="label">Account Code:</div>
        <div class="value">{{ job?.accountCode || '-' }}</div>
      </div>
      <div class="label-value">
        <div class="label">Supplier Tags:</div>
        <div class="value">
          <div *ngIf="job?.jobTags.length == 0">-</div>
          <div *ngIf="job?.jobTags">
            <span *ngFor="let tag of job?.jobTags; let i = index">
              {{ tag.description }}
              <span *ngIf="i < job?.jobTags?.length - 1">, </span>
            </span>
          </div>
        </div>
      </div>
      <div class="label-value">
        <div class="label">Purchase Channel:</div>
        <div class="value purchase-channel-value">
          <div>{{ job?.purchaseChannel || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</p-panel>
